module.exports = __webpack_public_path__ + "img/handyman.76f5defe.jpg";